<div class="wrapper">
  <report-viewer-navbar></report-viewer-navbar> <router-outlet> </router-outlet>
</div>
